module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Left 3-08ea39b4d7540f71db8556bd260d5b2b.svg";